import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useDSTMetaInfoStore } from '@stores/dst/dstStore';
import isEmptyObject from '@utils/isEmptyObject';
import { getAccessToken, getIsLoggedIn, getSearchToken } from '@selectors/auth';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getIsSubscribedToGoal } from '@selectors/subscription';
import { handleDSTRedirectAndFetch } from '../utils';

const useLanding = () => {
  const [loading, setLoading] = useState(false);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const { quizInfo } = useDSTMetaInfoStore();

  const {
    query: { goalSlug, goalUID }
  } = useRouter();

  const accessToken = useSelector(getAccessToken);
  const searchToken = useSelector(getSearchToken);
  const isPlusUser = useSelectorWithShallowEqual(
    getIsSubscribedToGoal(goalUID)
  );

  useEffect(() => {
    if (isLoggedIn && isEmptyObject(quizInfo)) {
      handleDSTRedirectAndFetch({
        isPlusUser,
        goalSlug,
        goalUID,
        accessToken,
        searchToken,
        onClient: true,
        setLoading
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, goalSlug, goalUID, isLoggedIn, quizInfo, searchToken]);

  return {
    loading
  };
};

export default useLanding;
